import { createAction } from '@reduxjs/toolkit';
import Scope from 'types/entities/Scope';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const injectScopes = createAction(BaselineAffectationType.InjectScopes, (scopes: Scope[]) => ({
  payload: { scopes },
}));

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.InjectScopes:
      return {
        ...state,
        scopes: action.payload.scopes,
      };
    default:
      return state;
  }
};
